import {
  LayoutDashboard,
  Package,
  FolderTree,
  Users,
  ShoppingCart,
  ShoppingBag,
  Settings,
  UserCheck,
  Wallet,
  TrendingUp,
  Shield,
  LucideIcon,
} from 'lucide-react';

export interface NavItem {
  path: string;
  label: string;
  icon: LucideIcon;
  /** Shu ruxsat bo'lmasa bo'lim ko'rinmaydi va route ham ochilmaydi. */
  need: string;
}

/**
 * Navigatsiyaning YAGONA manbasi.
 *
 * Sidebar, mobil pastki panel va route qo'riqchisi — uchalasi shu ro'yxatdan
 * o'qiydi. Ilgari bo'limlar `adminOnly` bayrog'i bilan yopilardi: u faqat
 * ikki holatni bilardi va tadbirkor uni o'zgartira olmasdi.
 */
export const NAV_ITEMS: NavItem[] = [
  { path: '/orders/new', label: 'Sotuv', icon: ShoppingBag, need: 'orders.create' },
  { path: '/', label: 'Dashboard', icon: LayoutDashboard, need: 'dashboard.view' },
  { path: '/orders', label: 'Buyurtmalar', icon: ShoppingCart, need: 'orders.view' },
  { path: '/products', label: 'Tovarlar', icon: Package, need: 'products.view' },
  { path: '/customers', label: 'Mijozlar', icon: Users, need: 'customers.view' },
  { path: '/categories', label: 'Kategoriyalar', icon: FolderTree, need: 'categories.view' },
  { path: '/sellers', label: 'Sotuvchilar', icon: UserCheck, need: 'employees.view' },
  { path: '/income', label: 'Kirimlar', icon: TrendingUp, need: 'income.view_summary' },
  { path: '/expenses', label: 'Chiqimlar', icon: Wallet, need: 'expenses.view' },
  { path: '/roles', label: 'Rollar', icon: Shield, need: 'roles.view' },
  { path: '/settings', label: 'Sozlamalar', icon: Settings, need: 'settings.view' },
];

/** Mobil pastki panelda doimiy joy oladigan bo'limlar soni; qolganlari Profil sahifasida. */
export const PRIMARY_COUNT = 4;

/** Route uchun kerakli ruxsat (ro'yxatda bo'lmasa — cheklovsiz). */
export function permissionForPath(pathname: string): string | null {
  // Eng uzun mos yo'l: `/orders/new` `/orders` dan oldin tanlansin.
  const match = [...NAV_ITEMS]
    .sort((a, b) => b.path.length - a.path.length)
    .find((item) => item.path === pathname);
  return match ? match.need : null;
}
